import React from 'react';
import AuthStore from './auth/auth.store';
import ICLibStore from './config/ICLib.store';
import ErrorStore from './error/error.store';
import SystemStore from './system/system.store';

export class Stores {
    AuthStore: AuthStore;
    ErrorStore: ErrorStore;
    ICLibStore: ICLibStore;
    SystemStore: SystemStore;

    constructor() {
        this.AuthStore = new AuthStore();
        this.ErrorStore = new ErrorStore();
        this.ICLibStore = new ICLibStore();
        this.SystemStore = new SystemStore();
    }
}

export const rootStore = new Stores();

const StoresContext = React.createContext(rootStore);

export const useStores = () => {
    const context = React.useContext(StoresContext);
    if (context === null) {
        throw new Error('You have forgotten to wrap your root component with RootStoreProvider');
    }
    return context;
};
